<ng-container *ngIf="useDashboardLayout(); else publicRoutes">
  <app-layout-shell></app-layout-shell>
  <!-- Layout shell renders its own router-outlet -->
  <!-- Footer not shown in dashboard layout for a clean app frame -->
</ng-container>

<ng-template #publicRoutes>
  <router-outlet />
</ng-template>